import React from 'react';
import { MenuListStyle } from './MenuList.style';

type MenuItemProps = {
  children: React.ReactNode;
};

const MenuList = ({ children }: MenuItemProps): JSX.Element => (
  <MenuListStyle>{children}</MenuListStyle>
);

export { MenuList };
